export const SIZE_OPTIONS = [
  {
    value: "16",
    label: "16 oz",
  },
  {
    value: "24",
    label: "24 oz",
  },
  {
    value: "32",
    label: "32 oz",
  },
]
